import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/_service/AuthService';
import { CustomerService } from 'src/_service/CustomerService';
import { ToastService } from 'src/_service/Toast.service';
import { Snackbarformat } from 'src/_theme/snackbarformats';
import { MyValidators } from 'src/_validators/MyValidators';
import { CmsTellAFriend } from 'src/_model/storyblock';
import { collapse } from 'src/_theme/animations';
import { StoryblokColorToColorscheme } from 'src/_theme/colorscheme';

@Component({
  selector: 'app-cms-tellafriend',
  templateUrl: './cms-tellafriend.component.html',
  styleUrl: './cms-tellafriend.component.scss',
  animations: [collapse],
  imports: [ReactiveFormsModule, TranslateModule, AsyncPipe],
})
export class CmsTellafriendComponent {

  private _tellafriend = new CmsTellAFriend(StoryblokColorToColorscheme['e-white'])
  @Input() set tellafriend(value: CmsTellAFriend) {
    this._tellafriend = new CmsTellAFriend(value.bgcolor)
  };
  get tellafriend() { return this._tellafriend; }

  tellafriendForm = new FormGroup({
    email: new FormControl('', { validators: Validators.required, asyncValidators: this._myValidators.Email }),
    body: new FormControl('', [Validators.required])
  });


  constructor(
    private _authService: AuthService,
    private _myValidators: MyValidators,
    private _customerService: CustomerService,
    private _toastService: ToastService,
  ) {
  }

  isAuthenticated$ = this._authService.isAuthenticated$;

  public hasError = (formGroup: FormGroup, controlName: string, errorName: string) => {
    if (formGroup.controls[controlName].touched)
      return formGroup.controls[controlName].hasError(errorName);
  }

  sendTellAFriend() {
    const value = this.tellafriendForm.value;
    if (!value.email || !value.body) return;

    this.tellafriendForm.reset()
    this._customerService.tellAFriend(value.email, value.body).subscribe(
      result => {
        console.log('succes!', result);
        this._toastService.openWithTranslate('tellafriend.if your friend is not yet a customer the email will be send', 'common.ok_dismiss', Snackbarformat)
      }, error => {
        console.log(error)
        this._toastService.openWithTranslate('tellafriend.if your friend is not yet a customer the email will be send', 'common.ok_dismiss', Snackbarformat)
      }
    )
  }
}
